import { render, staticRenderFns } from "./ManualChild.vue?vue&type=template&id=41fb11cc&"
import script from "./ManualChild.vue?vue&type=script&lang=js&"
export * from "./ManualChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports